import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import ScissorSwitch from './ScissorSwitch';
import ScissorStateComponent from '../../../Workstation/ScissorStateComponent';

export default function SelectScissorsContainer(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <div className={classes.scissorContainer}>
        <div className={classes.top}> <div className={classes.topScissors}>{t("Top scissors")}</div>
            <div className={classes.scissorStatus}>
                <ScissorStateComponent size={"XS"} selectedWorkstation={props.workstation.selectedWorkstation} upper></ScissorStateComponent>
            </div>
        </div>
        <div className={classes.zones}>
            {props.zonesWithScissors.map(x => {

                let checked = false
                let disabled = true

                if (x.used) {
                    disabled = true
                }
                if (x.scissor === 0) {
                    checked = true
                }

                if (props.selectedZones.length > 0) {
                    if (props.selectedZones.find(y => y.zone === x.zone)) {
                        checked = props.selectedZones.find(y => y.zone === x.zone).scissor === 0
                        disabled = false
                    }
                }

                return (
                    <div className={classes.switchContainer} key={x.zone}>
                        <ScissorSwitch
                            checked={checked}
                            onChange={() => props.switchScissor(x)}
                            name="multipleOrders"
                            disabled={disabled}
                        />
                    </div>
                )
            }
            )}

        </div>
        <div className={classes.bottom}>{t("Bottom scissors")}</div>
        <div className={classes.scissorStatus}>
            <ScissorStateComponent size={"XS"} selectedWorkstation={props.workstation.selectedWorkstation} lower></ScissorStateComponent>
        </div>
    </div>
}

const useStyles = makeStyles({
    scissorContainer: {
        margin: "10px",
        paddingLeft: "5px"
    },
    zones: {
        marginTop: "10px"
    },
    top: {
        width: "100%",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
    },
    bottom: {
        width: "100%",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center"
    },
    switchContainer: {
        width: "55px",
        height: "90px",
        float: "left",
        position: "relative",
        right: "20px",
        top: "5px"
    },
    topScissors: {
    },
    scrapButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        fontSize: "8px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        height: "20px",
        width: "60px",
        borderRadius: "10px",
        marginTop: "5px"
    },
    scissorStatus: {
        width: "100%",
        textAlign: "center"
    }
});